import React from 'react'

function Account() {
  return (
    <div>
      <p style={{color:'red'}}>Hello</p>
    </div>
  )
}

export default Account
